import React, { useState } from "react";
import DefaultAvatar from "@/components/site/DefaultAvatar";
import { api } from "@/lib/api";

/**
 * UserAvatar — shows the user's uploaded picture if set; otherwise falls back
 * to the deterministic Draftwave-branded animated default. Resilient to broken
 * image URLs (falls back on error).
 */
export default function UserAvatar({
  user,
  size = 40,
  animated = true,
  className = "",
  testid,
}) {
  const [broken, setBroken] = useState(false);
  const seed = user?.username || user?.email || user?.id || "draftwave";
  const src = !broken && user?.picture ? absolutize(user.picture) : null;

  if (src) {
    return (
      <img
        src={src}
        alt={user?.name || user?.username || "User avatar"}
        width={size}
        height={size}
        onError={() => setBroken(true)}
        className={`rounded-full object-cover ${className}`}
        style={{ width: size, height: size }}
        data-testid={testid || "user-avatar-img"}
      />
    );
  }

  return (
    <span
      className={`inline-block rounded-full overflow-hidden bg-black/10 ${className}`}
      style={{ width: size, height: size }}
      data-testid={testid || "user-avatar-default"}
    >
      <DefaultAvatar seed={seed} size={size} animated={animated} />
    </span>
  );
}

function absolutize(url) {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  // /api/... — prefix backend base URL
  const base = api?.defaults?.baseURL || "";
  if (base && url.startsWith("/api/")) {
    // baseURL already ends with /api → strip the /api from url
    return base + url.replace(/^\/api/, "");
  }
  return url;
}
